import AppSuppliersIndex from "./supplier.vue";
import AppSuppliersList from "./list/list.vue";
import AppSuppliersItem from "./item/item.vue";

const routes = [
  {
    path: "/supplier",
    component: AppSuppliersIndex,
    meta: {
      auth: {
        roles: "supplier.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "supplier.index",
        component: AppSuppliersList,
        meta: {
          auth: {
            roles: "supplier.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "supplier.create",
        component: AppSuppliersItem,
        meta: {
          auth: {
            roles: "supplier.create",
            redirect: { name: "supplier.index" }
          }
        }
      },
      {
        path: ":id",
        name: "supplier.edit",
        component: AppSuppliersItem,
        meta: {
          auth: {
            roles: "supplier.update",
            redirect: { name: "supplier.index" }
          }
        }
      }
    ]
  }
];

export default routes;
